export default __webpack_public_path__ + "static/media/23.111be78b.png";